import {
    Container,
    Row,
    Col
} from "reactstrap";

import {
    FiPlay
} from "react-icons/fi";

import "./CourseDemoVideos.css";

function CourseDemoVideos({
    videos = []
}) {

    if (!videos.length) {
        return null;
    }

    return (
        <section className="course-demo-videos">

            <Container>

                {/* Section Header */}

                <div className="course-demo-header">

                    <span className="course-demo-label">
                        SAMPLE CLASSES & PROJECTS
                    </span>

                    <h2>
                        Demo Videos
                    </h2>

                    <p>
                        Explore sample training sessions and
                        real-world student projects to understand
                        how the course is taught in practice.
                    </p>

                </div>


                {/* Videos */}

                <Row className="g-4">

                    {videos.map((video, index) => (

                        <Col
                            lg="6"
                            md="6"
                            sm="12"
                            key={index}
                        >

                            <div className="course-video-card">

                                {/* Video */}

                                <div className="course-video-wrapper">

                                    <iframe
                                        src={video.videoUrl}
                                        title={video.title}
                                        loading="lazy"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        allowFullScreen
                                    />

                                    <div className="course-video-play-icon">
                                        <FiPlay />
                                    </div>

                                </div>


                                {/* Content */}

                                <div className="course-video-content">

                                    <span className="course-video-category">
                                        {video.category}
                                    </span>

                                    <h3>
                                        {video.title}
                                    </h3>

                                </div>

                            </div>

                        </Col>

                    ))}

                </Row>

            </Container>

        </section>
    );
}

export default CourseDemoVideos;